import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IApiResult } from '../shared/models/api-result';
import { ApiUrlProvider } from './api-url.provider';
import { IRosterSettings } from '../shared/models/roster/roster-settings';

@Injectable({
  providedIn: 'root'
})
export class RosterSettingsService {
  constructor(private http: HttpClient, private apiUrlProvider: ApiUrlProvider) { }
  
  getAll(): Observable<IApiResult<IRosterSettings>>{
    return this.http.get<IApiResult<IRosterSettings>>(`${this.apiUrlProvider.url}/RosterSettings`);
  }
}
